$(document).ready(function() {
  setTimeout(function(){
    let elementsArray = document.querySelectorAll("input[type='email']"),
        submitButtons = document.querySelectorAll("form.klaviyo-form button:not([role='combobox'])");

    elementsArray.forEach(function(elem) {
        elem.addEventListener("change", function() {
          // create a class instance if it does not exist, get suggestions...
          var suggested = this.get("mailcheck").suggest(), self = this;

          // have a hint div underneath
          var hint = this.retrieve("hint") || new Element("div.hint", {
              events: {
                  "click:relay(a.confirm)": function(e) {
                      e & e.stop();
					  self.set('value', this.get('text'));
                   
                      hint.empty();
                  }
              }
          }).inject(this, 'after');
          this.store("hint", hint);

          // now see what is being suggested
          if (suggested) {
              //$(elem).closest('form').find('button').prop('disabled', true);
              //hint.set('html', 'Please type a valid email thanks!'.substitute(suggested));
              hint.set('html', 'Did you mean <a href="#" class="confirm">{full}</a>?'.substitute(suggested));
			  $(elem).val(suggested.full);
            
          } else {
              // we have nothing!
              //$(elem).closest('form').find('button').prop('disabled', false);
              hint.empty();
          }
        });
    
        /* enter key case */
      /*
        elem.addEventListener("keypress", function(e) {
          var suggestedFromLocal = localStorage.getItem('suggestedEmail');
          console.log('suggestedFromLocal');
          console.log(suggestedFromLocal);
          console.log(e.keyCode);
            // create a class instance if it does not exist, get suggestions...
            var suggested = this.get("mailcheck").suggest();  
            // now see what is being suggested
            if (suggested) {
              console.log(suggested);
              //e.preventDefault();
              //e.stopPropagation();
              //document.getElementById($(elem).attr('id')).value = suggested.full;
              //$(elem).val(suggested.full);
              console.log('setting input and local storage');
              localStorage.setItem('suggestedEmail', suggested.full);
            } 
          
            if (e.keyCode === 13) {
              e.preventDefault();
              e.stopPropagation();
              
              console.log('clicking here');
              if (suggestedFromLocal) {
                console.log('grabbing from local storage');
                //$(elem).val(suggestedFromLocal);

              }
                console.log($(elem).val());              
              localStorage.removeItem('suggestedEmail');
              $(elem).closest('form').find('button:not([role="combobox"])').click();
            }

        });
      
    });
    submitButtons.forEach(function(button) {
      
      $(button).on('click', function(e) {
          //e.preventDefault();
          //e.stopPropagation();
        
          var formId = $('#form_id_clicked').attr('form_id_clicked'),
              emailHtml = $('#' + formId + ' input[type="email"]')[0],
              suggested = emailHtml.get("mailcheck").suggest();
          console.log(suggested);
          if (suggested) {
            $('#' + formId + ' input[type="email"]').val(suggested.full);
          }
          
          
      });
      
      button.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
        
          var formId = $('#form_id_clicked').attr('form_id_clicked'),
              emailHtml = $('#' + formId + ' input[type="email"]')[0],
              suggested = emailHtml.get("mailcheck").suggest();
          console.log(suggested);
          if (suggested) {
            $('#' + formId + ' input[type="email"]').val(suggested.full);
          }
          
          $(button).click();
      });
      
    });
    */
              
      
    });
  }, 3000);
});